<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="profile_id"
        class="elevation-1">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPoE profile bindings</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">

            <vif_box v-model="show_vif_box"
                @canceled="vif_box_on_cancel" 
                @selected="vif_box_on_select($event)">
            </vif_box>

            <ipoe_profile_box v-model="show_ipoe_profile_box"
                @canceled="ipoe_profile_box_on_cancel" 
                @selected="ipoe_profile_box_on_select($event)">
            </ipoe_profile_box>

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item(item)"
                    color="primary" dark class="mb-2"
                    v-bind="props"
                    >
                    Add binding
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ edit_caption }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.vif_name"
                                label="VIF name">
                            <template #append>
                                <v-btn @click="open_vif_box()">...</v-btn>
                            </template>                          
                        </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider> 

                        <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                            <v-text-field
                                v-model="edited_item.profile_id"
                                label="IPoE Profile ID">
                            <template #append>
                                <v-btn @click="open_ipoe_profile_box()">...</v-btn>
                            </template>                          
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>   
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="edited_index !== -1" color="blue darken-1"
                        text @click="close">Close</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1"
                        text @click="close">Cancel</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>
    
        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import vif_box from "../components/vif_box.vue";
import ipoe_profile_box from "../components/ipoe_profile_box.vue";

import "../validation_rules.js";

export default {
name: "ipoe_profile_bindings",
components: {
    Treeselect, ValidationProvider, ValidationObserver, vif_box, ipoe_profile_box
},
data: () => ({
    profile_map: {}, // Added profile_map here
    show_vif_box: false,
    show_ipoe_profile_box: false,

    edit_caption: '',
    search: '',
    dialog: false,

    headers: [
        { text: 'VIF name', value: 'vif_name', align: 'start' },
        { text: 'Port ID', value: 'port_id' },
        { text: 'SVID', value: 'svid' },
        { text: 'CVID', value: 'cvid' },
        { text: 'IPoE profile ID', value: 'profile_id' },
        { text: 'IPoE profile name', value: 'profile_name' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        vif_name: '',
        port_id: '',
        svid: '',
        cvid: '',
        profile_id: '',
    },
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    async initialize() {
        try {
            const [bindings_response, profiles_response] = await Promise.all([
                api_client.run_get_query('/ipoe/profile/show_bindings'),
                api_client.run_get_query('/ipoe/profiles')
            ]);

            const profiles = profiles_response.data;
            const profile_map = profiles.reduce((map, profile) => {
                map[profile.id] = profile.name;
                return map;
            }, {});
            this.profile_map = profile_map; // Store the map

            const bindings = bindings_response.data;
            this.items = bindings.map(item => ({
                ...item,
                profile_name: this.profile_map[item.profile_id] || 'N/A' // Use this.profile_map
            }));
        }
        catch (error) {
            console.error("Error initializing IPoE profile bindings:", error);
            this.$fire({title: "Initialization failed", 
                text: `Could not load profile bindings or profiles: ${error}`, type: "warning"});
        }
    },

    new_item() {
        this.edit_caption = 'Add a new IPoE profile binding';
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete a IPoE profile binding VIF: " +
            this.edited_item.vif_name + ' -> profile_id: ' + this.edited_item.profile_id + "?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('/ipoe/profile/del_binding', {
            id: this.edited_item.profile_id,
            vif_name: this.edited_item.vif_name,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items.splice(this.edited_index, 1);
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save() {
        api_client.run_post_query('/ipoe/profile/add_binding', {
            id: this.edited_item.profile_id,
            vif_name: this.edited_item.vif_name,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items.push({
                    vif_name: this.edited_item.vif_name,
                    port_id: '', // Assuming these are populated later or not needed immediately
                    svid: '',    // Assuming these are populated later or not needed immediately
                    cvid: '',    // Assuming these are populated later or not needed immediately
                    profile_id: this.edited_item.profile_id,
                    profile_name: this.profile_map[this.edited_item.profile_id] || 'N/A' // Add profile name here
                });
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    open_vif_box() {
        this.show_vif_box = true;
    },

    vif_box_on_cancel() {
        this.show_vif_box = false;
    },

    vif_box_on_select(data) {
        this.edited_item.vif_name = data.name;
        this.vif_box_on_cancel();
    },

    open_ipoe_profile_box() {
        this.show_ipoe_profile_box = true;
    },

    ipoe_profile_box_on_cancel() {
        this.show_ipoe_profile_box = false;
    },

    ipoe_profile_box_on_select(profile_id) {
        this.edited_item.profile_id = profile_id;
        this.ipoe_profile_box_on_cancel();
    },
}

};
</script>
